<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">情報分析 / 會員APP訂餐分析</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">品牌：</label>
                  <div class="col-md-4">
                    <select
                      name="queryBrandsCode"
                      class="form-control"
                      v-model="queryBrandsCode"
                    >
                    <option v-bind:value="''" :key="''">全部</option>
                    <option
                      v-for="x in selectListBrands"
                      v-bind:value="x.Code"
                      :key="x.Code"
                    >{{x.Text}}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">日期：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="sdate">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="edate">
                  </div>
                </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">會員分類：</label>
                <div class="col-md-3">
                  <select class="form-control col-md-9" id="membergradeid" name="membergradeid" v-model="membergradeid">
                    <option v-bind:value="0" :key="0">全部</option>
                    <option v-bind:value="10" :key="10">基本會員</option>
                    <option v-bind:value="20" :key="20">正式會員</option>
                  </select>
                </div>
                <label class="control-label col-md-2 mt-2 text-right">會員年齡：</label>
                <div class="col-md-3">
                  <select class="form-control col-md-9" id="age" name="age" v-model="age" v-if='membergradeid!="10"'>
                    <option v-bind:value="0" :key="0">全部</option>
                    <option v-bind:value="1" :key="1">20以下</option>
                    <option v-bind:value="2" :key="2">20~29</option>
                    <option v-bind:value="3" :key="3">30~39</option>
                    <option v-bind:value="4" :key="4">40~49</option>
                    <option v-bind:value="5" :key="5">50~59</option>
                    <option v-bind:value="6" :key="6">60~69</option>
                    <option v-bind:value="7" :key="7">70~79</option>
                    <option v-bind:value="8" :key="8">80歲以上</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">會員性別：</label>
                <div class="col-md-3">
                  <select class="form-control col-md-9" id="membergender" name="membergender" v-model="membergender" v-if="membergradeid!='10'">
                    <option v-bind:value="''" :key="''">全部</option>
                    <option v-bind:value="'male'" :key="'male'">男</option>
                    <option v-bind:value="'female'" :key="'female'">女</option>
                    <option v-bind:value="'private'" :key="'private'">不公開</option>
                  </select>
                </div>
                <label class="control-label col-md-2 mt-2 text-right">地區：</label>
                <div class="col-md-3">
                  <select class="form-control col-md-9" id="city" name="city" v-model="city">
                    <option v-bind:value="''" :key="''">全部</option>
                    <option v-for="x in citylist" v-bind:value="x.City" :key="x.City">{{x.City}}</option>
                  </select>
                </div>
                <div class="col-lg-2mt-2">
                    <button type="button" class="btn btn-warning text-white" @click="getinformationcoupon(1)">查詢</button>
                </div>
              </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>
      <b-card class="bg-default-card">
        <div class="row" style="height: 280px">
          <div class="col-lg-6">
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th>項目</th>
                  <th>訂餐次數</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>基本會員</td>
                  <td>{{TempMember}}</td>
                </tr>
                <tr>
                  <td>正式會員</td>
                  <td>{{OneMember}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-lg-6">
            <IEcharts :option="pie" :loading="loading" @ready="onReady" @click="onClick"></IEcharts>
          </div>
        </div>
      </b-card>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th>手機號碼</th>
                  <th>姓名</th>
                  <th>性別</th>
                  <th>訂餐次數</th>
                  <th>總金額</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="x in coupon" :key="x.MemberID">
                  <td>{{x.Mobile}}</td>
                  <td>{{x.Name}}</td>
                  <td>{{x.Gender == 'male' ? '男': x.Gender == 'female' ? '女': x.Gender == 'private' ? '不公開' : '' }}</td>
                  <td>{{x.Count}}</td>
                  <td>{{x.Total}}</td>
                </tr>
              </tbody>
            </table>
            <div class="row" style="padding: 0 1rem">
              <b-pagination size="md" :total-rows="count" v-model="currentPage" :per-page="perpage" @change="getinformationcoupon"></b-pagination>
              <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{count}}筆</label>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import miniToastr from 'mini-toastr'
import IEcharts from 'vue-echarts-v3/src/full.js'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
export default {
  name: 'echarts',
  components: {
    IEcharts
  },
  data () {
    return {
      citylist: [], // 地區類別下拉
      selectListBrands: [], // 品牌下拉選單

      queryBrandsCode: "",

      sdate: '',
      edate: '',
      membergradeid: 0, // 會員類型
      age: 0, // 年齡
      membergender: '', // 性別
      city: '', // 地區

      TempMember: 0,
      OneMember: 0,

      // pie chart
      serverdata: [],
      instances: [],
      loading: false,

      pie: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} 張({d} %)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          textStyle: {
            fontWeight: 'bold',
            fontSize: 18
          },
          data: ['基本會員', '正式會員']
        },
        series: [{
          name: '會員',
          type: 'pie',
          radius: '70%',
          center: ['50%', '50%'],
          itemStyle: {
            normal: {
              label: {
                textStyle: {
                  fontSize: 18
                }
              }
            },
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          data: [
            {value: 0, name: '基本會員', itemStyle: {normal: {color: '#A1A1A1'}}},
            {value: 0, name: '正式會員', itemStyle: {normal: {color: '#004f2d'}}}]
        }]
      },
      // pie chart

      coupon: [],
      currentPage: 1,
      perpage: 20,
      count: 0,
      startRowNum: 0,
      endRowNum: 0
    }
  },
  created () {
    this.setdate()
    this.getpost()
    this.getinformationcoupon(1)
    this.querySelectListBrands()
    this.FunctionPermission = getFunctionPermission('F25') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
  },
  methods: {
    onReady (instance) {
      this.instances.push(instance)
    },
    getinformationcoupon (currentPage) {
      if (this.sdate === '' || this.edate === '' || this.sdate > this.edate) {
        miniToastr.error('請選擇正確的效期區間')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/memberAppOrder', {
        sdate: this.sdate,
        edate: this.edate,
        membergradeid: this.membergradeid,
        age: this.age,
        membergender: this.membergender,
        city: this.city,
        toPage: currentPage,
        perPage: this.perpage,
        brandCode: this.queryBrandsCode,
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.pie.series[0].data = []
            this.coupon = response.data.data
            this.currentPage = currentPage
            this.TempMember = response.data.tempmember
            this.pie.series[0].data.push({value: this.TempMember, name: '基本會員', itemStyle: {normal: {color: '#A1A1A1'}}})
            this.OneMember = response.data.onemember
            this.pie.series[0].data.push({value: this.OneMember, name: '正式會員', itemStyle: {normal: {color: '#004f2d'}}})
            this.count = (response.data.count === undefined) ? 0 : response.data.count
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.perpage * (this.currentPage - 1) + 1
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.perpage > response.data.count) ? response.data.count : (this.currentPage * this.perpage) >= response.data.count ? response.data.count : this.currentPage * this.perpage
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log(error)
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    setdate () {
      var today = new Date()
      var todaymon = today.getMonth() + 1
      if (todaymon < 10) {
        todaymon = '0' + todaymon
      }

      var date = new Date()
      date.setMonth(date.getMonth())
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.sdate = year + '-' + mon + '-01'
      this.edate = year + '-' + todaymon + '-' + day
    },
    getpost () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getallstores/v1', {
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.citylist = response.data.data
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '資料讀取異常')
          this.$parent.Loading = false
        })
    }
    // onClick (event, instance, echarts) {
    //   console.log(event)
    // }
  }

}
</script>
<style scoped>
  .box-shadow {
    box-shadow: 0px 0px 1px 1px #cfcfcf;
  }
  .font_text {
    font-size: 19px;
    margin: 6px 0 7px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/information/memberAppOrder/List.vue